module.exports = __webpack_public_path__ + "assets/img/female-avatar.jpg?f6c7d7ab13b27387c32244365f231b27";